import { format } from 'date-fns';
import { getStaticRanges } from './getStaticRanges';
var DEFAULT_FORMAT = 'MMM d, yyyy';
var formatter = new Intl.DateTimeFormat('en', {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
});
export var getSelectedTimeFrame = function (range) {
    var _a, _b;
    return (_b = (_a = getStaticRanges().find(function (staticRange) { return staticRange.isSelected(range); })) === null || _a === void 0 ? void 0 : _a.label) !== null && _b !== void 0 ? _b : formatter.formatRange(range.startDate, range.endDate);
}; // Ex. Jul 1-31 2024, Aug 3 2024-Sept 5 2024, Jan 5 2018
export var formatSelectedDateRange = function (range) {
    var _a, _b;
    var formattedDateRange = format(new Date((_a = range.startDate) !== null && _a !== void 0 ? _a : 0), DEFAULT_FORMAT);
    var selectedTimeFrame = getSelectedTimeFrame(range);
    var onlyStartDate = ['Today', 'Yesterday'].includes(selectedTimeFrame);
    if (onlyStartDate)
        return formattedDateRange;
    return "".concat(formattedDateRange, " - ").concat(format(new Date((_b = range.endDate) !== null && _b !== void 0 ? _b : 0), DEFAULT_FORMAT));
};
